import { erpAxios } from '..';

const getAllNotifikacije = async (officerId, skip, take) => {
  const { data } = await erpAxios(`/sistemskeNotifikacije/all/${officerId}/${skip}/${take}`);
  return data;
};

export default getAllNotifikacije;